import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'app-no-factsheet',
  templateUrl: './no-factsheet.component.html',
  styleUrls: ['./no-factsheet.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false
})
export class NoFactsheetComponent {}
